// router/index.js 或者 main.js 中的路由配置部分
import Vue from 'vue';
import Router from 'vue-router';
import HomeView from '../views/HomeView.vue';
import CustomerCaseStudies from '../views/CustomerCaseStudies.vue';
import Contact from '../views/Contact.vue';
import PlatformFunctions from '../views/PlatformFunctions.vue';
import ServicesandSolutions from '../views/ServicesandSolutions.vue';
import Storefront from '../views/Storefront.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'HomeView',
      component: HomeView
    },
    {
      path: '/CustomerCaseStudies',
      name: 'customerCaseStudies',
      component: CustomerCaseStudies
    },
    {
      path: '/Contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/PlatformFunctions',
      name: 'platformFunctions',
      component: PlatformFunctions
    },
    {
      path: '/ServicesandSolutions',
      name: 'servicesandSolutions',
      component: ServicesandSolutions
    },
    {
      path: '/Storefront',
      name: 'storefront',
      component: Storefront
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;